import { useNavigate } from 'react-router-dom';
import { getUserLocale } from '../utils';

export const useCustomNavigate = () => {
	const locale = getUserLocale();
	const navigate = useNavigate();

	return function (path: string, localLocale?: string) {
		navigate(path.replace(':locale', localLocale ? localLocale : locale) + window.location.search);
	};
};
